(() => {
  const settle = () => {
    const items = document.querySelectorAll([
      '.peh-pathways__card',
      '.peh-home-events .peh-event-card',
      '.peh-route-pages-experience-lab .peh-experience-card',
      '.peh-route-pages-experience-lab .peh-format-card',
      '.peh-route-pages-play-everyday .peh-person',
      '.peh-route-pages-lavoriamo-insieme .peh-work-entry__option',
      '.peh-route-pages-lavoriamo-insieme .peh-work-line__grid'
    ].join(','));

    items.forEach((item, index) => {
      item.classList.add('peh-v2-shift');
      item.style.setProperty('--peh-order', String(index % 4));
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-peh-settled'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-peh-settled');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    items.forEach((item) => observer.observe(item));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', settle, { once: true });
  } else {
    settle();
  }
})();
